import { getUserFacingAudioMessage } from "@/lib/livekit-user-facing-messages";
import { AnimatePresence, motion } from "framer-motion";
import { Mic, X } from "lucide-react";

interface AudioTrackErrorProps {
  audioTrackError?: string | null;
  audioRetryCount?: number;
  retryAudioTrack?: () => void;
  clearAudioErrors?: () => void;
}

export function AudioTrackError({
  audioTrackError,
  retryAudioTrack,
  clearAudioErrors,
}: AudioTrackErrorProps) {
  if (!audioTrackError) return null;

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -20 }}
        className="mx-4 mb-4 rounded-lg border border-amber-400/25 bg-amber-400/10 p-4"
      >
        <div className="flex items-start gap-3">
          <div className="flex-shrink-0 rounded-md bg-amber-400/15 p-2">
            <Mic size={20} className="text-amber-400" />
          </div>
          <div className="flex-1 min-w-0">
            <div className="text-amber-200 font-medium mb-1">We couldn't start the audio</div>
            <div className="text-amber-300/80 text-sm mb-3 leading-relaxed">
              {getUserFacingAudioMessage(audioTrackError)}
            </div>
            {retryAudioTrack && (
              <button
                onClick={retryAudioTrack}
                className="rounded-md border border-amber-300/20 bg-amber-400/10 px-3 py-1.5 text-sm text-amber-100 transition-colors hover:bg-amber-400/20"
              >
                Try audio again
              </button>
            )}
          </div>
          {clearAudioErrors && (
            <button
              onClick={clearAudioErrors}
              className="flex h-8 w-8 items-center justify-center rounded-md text-amber-200/55 transition-colors hover:bg-amber-400/10 hover:text-amber-100"
              aria-label="Dismiss message"
            >
              <X size={15} />
            </button>
          )}
        </div>
      </motion.div>
    </AnimatePresence>
  );
}
